import Model from "lib/model";
import assign from "lodash/assign";
import isObject from "lodash/isObject";
import { format } from "lib/globalize-util";

export default Model.extend({
    props: {
        line1: { type: "string", required: true },
        line2: { type: "string", default: "" },
        city: "string",
        state: "string",
        zip: "string",
        region: "string",
        postcode: "string",
        warehouse: { type: "objectId" },
        country: {
            type: "string",
            default: "US",
            required: true,
        },
    },

    set: function (key, value, options) {
        if (isObject(key)) {
            if (key.line_1 && !key.line1) {
                key.line1 = key.line_1;
            }
            if (key.line_2 && !key.line2) {
                key.line2 = key.line_2;
            }
        }

        Model.prototype.set.call(this, key, value, options);
    },

    _validate: function (attrs, options) {
        if (!options.validate || !this.validate) {
            return true;
        }
        if (!options.validateJustCurrentAttrs) {
            attrs = assign({}, this.attributes, attrs);
        }
        const error = (this.validationError = this.validate(attrs, options) || null);
        if (!error) {
            return true;
        }
        this.trigger("invalid", this, error, assign(options || {}, { validationError: error }));
        return false;
    },

    validate: function (attrs) {
        const errors = {};
        if (this.isNew()) {
            Object.keys(attrs).forEach((key) => {
                const error = this.validateFieldForNewModel(key, attrs[key]);
                if (error) {
                    errors[key] = error;
                }
            });
        }
        return Object.keys(errors).length ? errors : false;
    },

    validateFieldForNewModel: function (key, value) {
        let error;
        switch (key) {
            case "line1":
                if (!value || !value.length) {
                    error = format("Address is required");
                }
                break;
            case "city":
                if (!value || !value.length) {
                    error = format("City is required");
                }
                break;
            case "region":
                if ((!value || !value.length) && this.country !== "US") {
                    error = format("Region is required");
                }
                break;
            case "postcode":
                if ((!value || !value.length) && this.country !== "US") {
                    error = format("Postcode is required");
                }
                break;
            case "state":
                if ((!value || !value.length) && this.country === "US") {
                    error = format("State is required");
                }
                break;
            case "zip":
                if (this.country === "US" && !value?.match(/^[0-9]{5}(?:-[0-9]{4})?$/)) {
                    error = format("A valid zipcode is required");
                }
                break;
            default:
                error = false;
                break;
        }
        return error;
    },
});
